import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ExtraCampaignsServiceProvider } from '../../api/extra-campaigns'

const ExtraCampaignsService = ExtraCampaignsServiceProvider()
const name = 'getExtraCurrentEmailTemplate'

export default (id) => (asyncAction(
  name,
  ExtraCampaignsService.getExtraCurrentEmailTemplate,
  { id }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/extra-campaign/getExtraCurrentEmailTemplate.js